{
  "navigation.footer.tagline": "Your care, your creation, your story.",
  "navigation.footer.play.heading": "Play",
  "navigation.footer.battleGuide": "Battle Guide",
  "navigation.footer.collection": "Collection",
  "navigation.footer.resources.heading": "Resources",
  "navigation.footer.help": "Help",
  "navigation.footer.terms": "Terms of Service",
  "navigation.footer.privacy": "Privacy Policy",
  "navigation.footer.cookieSettings": "Cookie settings",
  "navigation.footer.news": "News",
  "navigation.footer.social.heading": "Follow the signal",
  "navigation.footer.social.x": "Follow Suikamon on X (opens in new tab)",
  "navigation.footer.social.discord": "Join Suikamon on Discord (opens in new tab)",
  "navigation.footer.social.telegram": "Join Suikamon on Telegram (opens in new tab)",
  "navigation.footer.copyright": "© {year} Suikamon — an independent hobby project. {version}",
  "navigation.footer.motto": "Built for dreamers, streamers, and arcology keepers.",
  "navigation.game.ariaLabel": "Game navigation",
  "navigation.game.homeLogo": "Suikamon home",
  "navigation.game.newNotification": "{label} (new notification)",
  "navigation.game.home": "Home",
  "navigation.game.more": "More",
  "navigation.game.menuTitle": "Menu",
  "navigation.game.allDestinations": "All destinations",
  "navigation.game.logout": "Log out",
  "navigation.game.trainerMenu": "Trainer menu: profile, help, sound",
  "navigation.game.profile": "Profile",
  "navigation.game.help": "Help",
  "navigation.game.yourProfile": "Your profile",
  "navigation.game.openProfile": "{name} — open your profile",
  "navigation.game.suikaBalance": "Suika: {amount}",
  "navigation.game.suikaBalanceLow": "Suika: {amount}. Low — refill free",
  "navigation.sound.mute": "Mute game sound",
  "navigation.sound.unmute": "Unmute game sound",
  "navigation.sound.on": "Sound on",
  "navigation.sound.off": "Sound off",
  "navigation.tab.play": "Suikamon",
  "navigation.tab.playAria": "Your Suikamons",
  "navigation.tab.campaign": "Campaign",
  "navigation.tab.battle": "Battle",
  "navigation.tab.battleTraining": "Training",
  "navigation.tab.battleTrainingDesc": "Practice, no stakes",
  "navigation.tab.battleSolo": "Solo",
  "navigation.tab.battleSoloDesc": "Ranked 1v1",
  "navigation.tab.battleSquad": "Squad",
  "navigation.tab.battleSquadDesc": "Ranked team battles",
  "navigation.tab.store": "Store",
  "navigation.tab.storeAria": "Skill Store",
  "navigation.tab.adopt": "Adopt",
  "navigation.tab.adoptAria": "Adopt a Suikamon",
  "navigation.tab.collection": "Collection",
  "navigation.tab.rankings": "Rankings",
  "navigation.tab.story": "Story",
  "navigation.tab.help": "Help",
  "navigation.notFound.title": "Page not found",
  "navigation.notFound.subtitle": "This page does not exist.",
  "navigation.notFound.text": "The link may be mistyped, or the page may have moved. Here is where to go instead:",
  "navigation.notFound.home": "Suikamon home",
  "navigation.notFound.playFree": "Play free — pick a starter",
  "navigation.notFound.guide": "Game guide",
  "navigation.notFound.news": "News & patch notes",
  "navigation.app.loading": "Loading...",
  "navigation.app.redirecting": "Redirecting to {site}...",
  "navigation.app.signUp": "Sign up",
  "navigation.app.skipLink": "Skip to main content",
  "navigation.app.feedbackAria": "Send feedback on X/Twitter",
  "navigation.app.feedback": "Feedback",
  "navigation.app.contact": "Contact",
  "navigation.app.announcementAria": "Announcement: {message}",
  "navigation.consent.aria": "Analytics cookies",
  "navigation.consent.text": "We'd like to use analytics cookies to fix bugs and improve Suikamon. No ads, ever.",
  "navigation.consent.privacy": "Privacy",
  "navigation.consent.essential": "Only essential",
  "navigation.consent.accept": "Accept",
  "navigation.season.live": "Now Live",
  "navigation.season.welcome": "Welcome to Season {version}",
  "navigation.season.alt": "Season {version}",
  "navigation.season.cta": "Let's Battle!",
  "navigation.toast.copyPrompt": "Copy the error below:",
  "navigation.toast.copy": "Copy error details"
}
